import { render, staticRenderFns } from "./BookingComponent.vue?vue&type=template&id=868caf02"
import script from "./BookingComponent.vue?vue&type=script&lang=js"
export * from "./BookingComponent.vue?vue&type=script&lang=js"
import style0 from "./BookingComponent.vue?vue&type=style&index=0&id=868caf02&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports